@if (pendiente(); as p) {
    <div class="fixed inset-0 z-[900] flex items-center justify-center bg-slate-900/50 backdrop-blur-sm p-4" role="alertdialog" aria-modal="true" aria-labelledby="shift-gate-title">
        <div class="w-full max-w-md bg-white rounded-[28px] border border-slate-100 shadow-2xl p-8 text-center flex flex-col items-center gap-4">
            <div class="w-14 h-14 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center">
                <mat-icon class="!text-3xl !w-8 !h-8">lock</mat-icon>
            </div>
            <h2 id="shift-gate-title" class="text-2xl font-black text-slate-900 tracking-tight m-0">Caja en cambio de turno</h2>
            <p class="text-sm text-slate-600 leading-relaxed m-0">
                Entregó: <b>{{ p.handed_by_name }}</b> · {{ p.initiated_at | date:'HH:mm' }}<br>
                No se puede vender ni registrar movimientos hasta que la próxima vendedora valide lo que recibe.
            </p>

            @if (anulando()) {
                <div class="w-full flex flex-col gap-3 text-left">
                    <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Motivo de la anulación (opcional)</label>
                    <mat-form-field appearance="outline" class="w-full custom-field" subscriptSizing="dynamic">
                        <textarea matInput rows="2" [ngModel]="motivo()" (ngModelChange)="motivo.set($event)" [disabled]="procesando()" placeholder="No llegó la otra vendedora" id="shift-gate-reason"></textarea>
                    </mat-form-field>
                    <div class="flex justify-end gap-3">
                        <button mat-button type="button" class="btn-secondary-back" [disabled]="procesando()" (click)="cancelarAnulacion()" id="shift-gate-back-btn">Volver</button>
                        <button mat-flat-button color="warn" class="btn-primary-add" [disabled]="procesando()" (click)="confirmarAnulacion()" id="shift-gate-void-confirm-btn">
                            @if (procesando()) {
                                <mat-spinner diameter="18"></mat-spinner>
                            } @else {
                                Anular cambio de turno
                            }
                        </button>
                    </div>
                </div>
            } @else {
                <button mat-flat-button color="primary" class="btn-primary-add" (click)="validar()" id="shift-gate-validate-btn">Validar y recibir caja</button>
                <button mat-button type="button" class="btn-secondary-back" (click)="empezarAnulacion()" id="shift-gate-void-btn">Anular cambio de turno y seguir trabajando</button>
            }
        </div>
    </div>
}
